var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "convertConsultanttoREP", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content p-15" },
          [
            _vm._m(0),
            _c("div", { staticClass: "modal-body desc-text p-0 pt-15 pb-15" }, [
              _c(
                "div",
                { staticClass: "align-right" },
                [
                  _c(
                    "el-popover",
                    {
                      staticClass: "info-icon-class",
                      attrs: {
                        "popper-append-to-body": "false",
                        placement: "bottom-end",
                        trigger: "click",
                        "popper-class":
                          "popup-background tootip-custom-small-width-class",
                      },
                      on: {
                        show: function ($event) {
                          _vm.infoActive = true
                        },
                        hide: function ($event) {
                          _vm.infoActive = false
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "content" }, [
                        _vm._v(
                          ' By converting a user profile from "Consultant" to "REP Consultant", the user will: '
                        ),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "Get access to all RAMS representation accounts."
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              "Lose access to already assigned Accounts(Other than REP Accounts)."
                            ),
                          ]),
                          _c("li", [
                            _vm._v(
                              "Lose access to already assigned Smart Builder projects."
                            ),
                          ]),
                        ]),
                      ]),
                      !_vm.infoActive
                        ? _c("img", {
                            staticClass: "info-img",
                            attrs: {
                              slot: "reference",
                              src: "/static/images/icons/info_icon.svg",
                              alt: "info-icon",
                            },
                            slot: "reference",
                          })
                        : _vm._e(),
                      _vm.infoActive
                        ? _c("img", {
                            staticClass: "info-img",
                            attrs: {
                              slot: "reference",
                              src: "/static/images/icons/info_icon_active.svg",
                              alt: "infoactive-icon",
                            },
                            slot: "reference",
                          })
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "title-text center" }, [
                _vm._v(
                  "Are you sure you would like to convert the below Consultant to REP Consultant? "
                ),
                _c("div", { staticClass: "bold-text" }, [
                  _vm._v(
                    _vm._s(_vm.convertUserDetails.first_name) +
                      " " +
                      _vm._s(_vm.convertUserDetails.last_name)
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "modal-footer deactiveModal-bgcolor pl-0 pr-0" },
              [
                _vm._m(1),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-blue-button",
                        on: { click: _vm.convertConsultanttoREP },
                      },
                      [_vm._v("Convert")]
                    ),
                  ]
                ),
              ]
            ),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header deactiveModal-bgcolor" }, [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#convertConsultanttoREP",
          },
        },
        [_vm._v("×")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 mr-tp-10" },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-block emergo-white-button",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#convertConsultanttoREP",
            },
          },
          [_vm._v("Cancel")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }